import { render, staticRenderFns } from "./GroupsControl.vue?vue&type=template&id=6c51f077&scoped=true&"
import script from "./GroupsControl.vue?vue&type=script&lang=js&"
export * from "./GroupsControl.vue?vue&type=script&lang=js&"
import style0 from "./GroupsControl.vue?vue&type=style&index=0&id=6c51f077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51f077",
  null
  
)

export default component.exports